// extracted by mini-css-extract-plugin
module.exports = {"body_wrapper":"_id__body_wrapper__TJvwt","tip_card":"_id__tip_card__p2XyB"};